import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Tab,
  Tabs
} from '@material-ui/core';
import { getStoresAPI } from 'api';
import { TabPanel, TabContext } from '@material-ui/lab';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import BulkPriceUpdate from '../catalog/bulkPriceUpdate';
import UserStores from './UserStores';
import Stores from './Stores';
import FeatureFlipper from './FeatureFlipper/FeatureFlipper';
import StoreSubscriptionPlans from './StoreSubscriptionPlans';
import BannerSlides from './BannerSlides/BannerSlides';
import SMBanner from './SMBanner/BannerSlides';
import HelpConfigurations from './HelpPageConfigurations/HelpConfigurations';
import StoreSetupPrices from './StoreSetup';
import StoreSubscriptionCouponCodes from './SubscriptionCouponCodes';
import AdditionalSubscription from './AdditionalConfigurations/AdditionalSubscription';
import Report from './Report';
import TouchMdDetails from './TouchMdDetails';


const customTheme = createTheme({
  overrides: {
    MuiTabs: {
      flexContainer: {
        flexWrap: 'wrap',
        display: 'flex'
      }
    },
    MuiTab: {
      root: {
        '&.Mui-selected': {
          borderBottom: '2px solid #103A99',
          transitionDuration: '0.3s'
        }
      }
    }
  }
});

const AdminPage = () => {
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState('0');
  const {profile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  useEffect(() => {
    const params = new URLSearchParams({
      page: '1',
      limit: '10',
    }).toString();

    getStoresAPI({dispatch, params});
  }, []);

  const handleTabChange = (e, value) => setTabIndex(value);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y px-10 py-5 pb-25">
      <TabContext value={tabIndex}>
        <MuiThemeProvider theme={customTheme}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            TabIndicatorProps={{
              style: {display: 'none'}
            }}
          >
            {permissions?.adminUserStoresTab && <Tab className="capitalize font-medium" value="0" label="User Stores" />}
            {permissions?.adminStoresTab && <Tab className="capitalize font-medium" value="1" label="Stores" />}
            {permissions?.adminFeatureFlipperTab && <Tab className="capitalize font-medium" value="2" label="Feature Flipper" />}
            {permissions?.adminSubscriptionTierTab && <Tab className="capitalize font-medium" value="3" label="Store Subscription Plans" />}
            {permissions?.adminBannerSlidesTab && <Tab className="capitalize font-medium" value="4" label="Add Banner Slides" />}
            {permissions?.adminSMBannerTab && <Tab className="capitalize font-medium" value="5" label="Shopmanager Banner" />}
            <Tab className="capitalize font-medium" value="6" label="Edit Help Page" />
            <Tab className="capitalize font-medium" value="7" label="Store Setup Prices" />
            <Tab className="capitalize font-medium" value="8" label="Access Codes" />
            <Tab className="capitalize font-medium" value="9" label="Marketing Plans" />
            <Tab className="capitalize font-medium" value="10" label="TouchMD sync details" />
            {permissions?.adminSMReport && <Tab className="capitalize font-medium" value="11" label="Report" />}
            {permissions?.bulkPriceUpdate && <Tab className="capitalize font-medium" value="12" label="Bulk Price Update" />}
          </Tabs>
        </MuiThemeProvider>
        <TabPanel value="0">
          {permissions?.adminUserStoresTab && <UserStores />}
        </TabPanel>
        <TabPanel value="1">
          {permissions?.adminStoresTab && <Stores />}
        </TabPanel>
        <TabPanel value="2">
          {permissions?.adminFeatureFlipperTab && <FeatureFlipper />}
        </TabPanel>
        <TabPanel value="3">
          {permissions?.adminSubscriptionTierTab && <StoreSubscriptionPlans />}
        </TabPanel>
        <TabPanel value="4">
          {permissions?.adminBannerSlidesTab && <BannerSlides />}
        </TabPanel>
        <TabPanel value="5">
          {permissions?.adminSMBannerTab && <SMBanner />}
        </TabPanel>
        <TabPanel value="6">
          {permissions?.adminHelpConfigurations && <HelpConfigurations />}
        </TabPanel>
        <TabPanel value="7">
          <StoreSetupPrices />
        </TabPanel>
        <TabPanel value="8">
          <StoreSubscriptionCouponCodes />
        </TabPanel>
        <TabPanel value="9">
          <AdditionalSubscription />
        </TabPanel>
        <TabPanel value="10">
          <TouchMdDetails />
        </TabPanel>
        <TabPanel value="11">
          {permissions?.adminSMReport && <Report />}
        </TabPanel>
        <TabPanel value="12">
          {permissions?.bulkPriceUpdate && <BulkPriceUpdate />}
        </TabPanel>
      </TabContext>
    </div>
  );
};


export default AdminPage;
